export default __webpack_public_path__ + "static/media/aa.512d0956.jpg";